<template>
  <div>
    <div class="sccj-top-box">
      <SccjHeader />
    </div>
    <div class="resouce-data-box">
      <div class="container">
        <div class="data-label">
          <img class="title-img" src="../../assets/image/sccj/tongji.png" />
        </div>
        <div class="summary-list">
          <div class="summary-item">
            <div class="nums"><b>{{ dataSummary && dataSummary.num1 ? dataSummary.num1 : 0 }}</b>个</div>
            <div class="name">建设专业总数</div>
          </div>
          <div class="split-line"></div>
          <div class="summary-item">
            <div class="nums" @click="toLink(`/${school_code}/zy/elementGraph`)"><b>{{ dataSummary && dataSummary.num2
              ? dataSummary.num2 : 0 }}</b>个</div>
            <div class="name">涉及思政元素总数</div>
          </div>
          <div class="split-line"></div>
          <div class="summary-item">
            <div class="nums" @click="toLink(`/${school_code}/zy/szzyk`)"><b>{{ dataSummary && dataSummary.num3 ?
              dataSummary.num3 : 0 }}</b>个</div>
            <div class="name">思政元素库资源总数</div>
          </div>
          <div class="split-line"></div>
          <div class="summary-item">
            <div class="nums" @click="toLink(`/${school_code}/zy/alzyk`)"><b>{{ dataSummary && dataSummary.num4 ?
              dataSummary.num4 : 0 }}</b>个</div>
            <div class="name">案例库资源总数</div>
          </div>
          <div class="split-line"></div>
          <div class="summary-item">
            <div class="nums" @click="toLink(`/${school_code}/zy/szztk`)"><b>{{ dataSummary && dataSummary.num5 ?
              dataSummary.num5 : 0 }}</b>个</div>
            <div class="name">思政专题库专题总数</div>
          </div>
          <div class="split-line"></div>
          <div class="summary-item">
            <div class="nums" @click="toLink(`/${school_code}/zy/region`)"><b>{{ dataSummary && dataSummary.num6 ?
              dataSummary.num6 : 0 }}</b>个</div>
            <div class="name">四川区域资源总数</div>
          </div>
        </div>
      </div>
    </div>
    <div class="tupu-data-box">
      <div class="container">
        <img class="title-img" src="../../assets/image/sccj/szystp.png" />
      </div>
      <div class="tupu-con">
        <div class="to-tupu" @click="gotoPageTupu()"></div>
        <img class="con-img" src="../../assets/image/sccj/tupu-img.jpg" />
      </div>

    </div>
    <div class="recommend-class-box">
      <div class="container">
        <img class="title-img" src="../../assets/image/sccj/tjzy.png" />

        <div class="second-cate">
          <!-- <div :class="['second-item', cateIds == 0 ? 'active' : '' ]" @click="clickClassCate('')">推荐</div> -->
          <div :class="['second-item', cateIds == '坚守安全底线' ? 'active' : '']" @click="clickClassCate('坚守安全底线')">坚守安全底线
          </div>
          <div :class="['second-item', cateIds == '践行社会责任' ? 'active' : '']" @click="clickClassCate('践行社会责任')">践行社会责任
          </div>
          <div :class="['second-item', cateIds == '红色财经文化' ? 'active' : '']" @click="clickClassCate('红色财经文化')">红色财经文化
          </div>
          <div :class="['second-item', cateIds == '川商文化' ? 'active' : '']" @click="clickClassCate('川商文化')">川商文化</div>
          <div :class="['second-item', cateIds == '宪法法治意识' ? 'active' : '']" @click="clickClassCate('宪法法治意识')">宪法法治意识
          </div>
        </div>
        <div class="class-outer-box">
          <swiper ref="mySwiper" v-if="classaryList.length > 0" class="class-list" :options="swiperOption">
            <swiper-slide v-for="(item, index) in classaryList" :key="index">
              <div class="class-item" @click="goDetails(item)">
                <span :class="['type-icon', item.type == 1 ? 'word' : 'video']"></span>
                <div class="res-label">{{ item.title }}</div>
                <div class="res-tags">
                  <!-- <div class="tag-one" v-for="(t,tinx) in item.element_list" :key="tinx">{{t.name}}</div> -->
                  <div class="tag-one" v-for="(item, index) in item.element_format_list" :key="index">
                    <span v-for="(sub, sinx) in item.nameFormat" :key="sinx">{{ sub }}<template
                        v-if="((sinx + 1) < item.nameFormat.length)"> - </template></span>
                  </div>
                </div>
                <div class="source">{{ item.source }}</div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
          <div class="more-link" @click="gotoPageSzzyk()">查看更多 ></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// 引入插件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { mapState, mapActions } from "vuex";
import services from "../../assets/js/services";
import utils from "../../assets/js/utils";
import SccjHeader from "../../components/SccjHeader.vue";

export default {
  name: "sccjHome",
  components: {
    swiper,
    swiperSlide,
    SccjHeader,
  },
  data() {
    return {
      services,
      school_code: localStorage.getItem("schoolCode"),
      isMobile: utils.isMobile(),
      swiperOption: {
        // loop: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        slidesPerColumn: 2,
        autoplay: {
          pauseOnMouseEnter: true,
        },
        speed: 400, // 切换图片速度
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // // 修改swiper自己或子元素时，自动初始化swiper
        // observer: true,
        // // 修改swiper的父元素时，自动初始化swiper
        // observeParents: true,
      },
      dataSummary: null,
      classaryList: [], //首页banner
      cateIds: '坚守安全底线',
    };
  },
  computed: {
    ...mapState({
      schoolInfo: (state) => state.appsLogin.schoolInfo,
      schoolMenu: state => state.appsLogin.schoolMenu,
    }),
    mySwiper() {
      return this.$refs.mySwiper && this.$refs.mySwiper.swiper;
    },
  },
  created() {
    if (this.school_code != utils.sccj_code) {
      this.$router.push({
        path: `/${this.school_code}/zy`
      })
    }
  },
  async mounted() {
    await this.getSchoolMenuData();
    this.getRecommendResource()
    this.getResourceSummary()
  },
  methods: {
    ...mapActions([
      "goAppsDetailsBeforeLogin", "getSchoolMenuStatus"
    ]),
    async getSchoolMenuData() {
      if (!this.schoolMenu) {
        await this.getSchoolMenuStatus(this.school_code);
      }
    },
    getRecommendResource() {
      let that = this
      let param = { length: '27', school_code: utils.sccj_code }
      if (that.cateIds) {
        param.element_name = that.cateIds
      }
      services.getGroupResource(param).then(res => {
        if (res.code == '0000' && res.data) {
          if (res.data.items && res.data.items.length > 0) {
            res.data.items.forEach(item => {
              if (item.element_names && item.element_names.length > 0) {
                let eleArr = utils.transformElementFormat(item.element_names)
                item.element_format_list = eleArr
              }
            })
          }
          this.classaryList = res.data.items

        }
      })
    },
    getResourceSummary() {
      let that = this
      services.getResourceStat({
        school_code: that.school_code,
        open_ability: that.schoolMenu.open_ability,
        open_element: that.schoolMenu.open_element,
      }).then(res => {
        if (res.code == '0000') {
          that.dataSummary = res.data
          that.mySwiper?.update();
        }
      })
    },
    gotoPageSzzyk() {
      let params = {}
      if (this.cateIds == '坚守安全底线') {
        params.element_first_id = '691fd19ad507500ca21cc347'
        params.element_second_id = '691fd19ad507500ca21cc352'
      } else if (this.cateIds == '践行社会责任') {
        params.element_first_id = '691fd19ad507500ca21cc347'
        params.element_second_id = '691fd19ad507500ca21cc351'
      } else if (this.cateIds == '红色财经文化') {
        params.element_first_id = '691fd19ad507500ca21cc348'
        params.element_second_id = '691fd19ad507500ca21cc353'
      } else if (this.cateIds == '川商文化') {
        params.element_first_id = '691fd19ad507500ca21cc348'
        params.element_second_id = '691fd19ad507500ca21cc354'
      } else if (this.cateIds == '宪法法治意识') {
        params.element_first_id = '691fd19ad507500ca21cc349'
      }

      let routeUrl = this.$router.resolve({
        path: `/${this.school_code}/zy/szzyk`,
        query: params
      })
      window.open(routeUrl.href, '_blank');
    },
    gotoPageTupu() {
      let routeUrl = this.$router.resolve({
        path: `/${this.school_code}/zy/elementGraph`,
        // query: params
      })
      window.open(routeUrl.href, '_blank');
    },
    clickClassCate(name) {
      this.cateIds = name
      this.getRecommendResource()
    },
    // 思政资源库详情
    goDetails(item) {
      this.goAppsDetailsBeforeLogin().then(() => {
        // if (item.is_open == 2) {
        let params = {
          id: item.id,
        };
        if (this.currentLevel1 && this.currentLevel1.id) {
          params.subject_big_id = this.currentLevel1.id
        }
        if (this.currentLevel2 && this.currentLevel2.id) {
          params.subject_small_id = this.currentLevel2.id
        }
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/zy/szzyk/details`,
          query: params
        })
        window.open(routeUrl.href, utils.isMobile() ? '_self' : '_blank');
        // } else {
        //   // that.noAuthMessageModal()
        //   this.dialogConfig.name = "appleRes"
        // }
      })
    },
    swiperEnter() {
      this.mySwiper && this.mySwiper.autoplay.stop();
    },
    swiperLeave() {
      this.mySwiper && this.mySwiper.autoplay.start();
    },
    toLink(path) {
      let routeUrl = this.$router.resolve({
        path: path,
      })
      window.open(routeUrl.href, utils.isMobile() ? '_self' : '_blank');
    }
  },
};
</script>

<style lang="less" scoped>
.sccj-top-box {
  position: relative;
  width: 100%;
  height: 720px;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("../../assets/image/sccj/banner.jpg");
  background-size: cover;
}

.resouce-data-box {
  // height: 145px;
  background: #c7171d;
  position: relative;
  z-index: 10;

  .data-label {
    .title-img {
      width: auto;
      height: 44px;
      margin: 0 auto 22px;
      display: block;
    }


  }



  .summary-list {
    width: 1100px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .summary-item {
      flex: 1;
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding-bottom: 20px;

      .nums {
        flex: 1;
        text-align: left;
        font-weight: 400;
        font-size: 12px;
        margin-bottom: 4px;
        color: #fbac94;
        cursor: pointer;

        b {
          font-weight: bold;
          font-size: 26px;
          color: #ffeb9d;
          display: inline-block;
          margin-right: 6px;
        }
      }

      .name {
        flex: 1;
        font-weight: bold;
        font-size: 14px;
        color: #fbac94;
      }
    }

    .split-line {
      width: 1px;
      height: 47px;
      background: #e76e72;
      margin: 0 30px;
    }
  }
}

.tupu-data-box {
  margin-top: -50px;
  position: relative;
  z-index: 1;
  width: 100%;
  padding-bottom: 130px;

  .title-img {
    margin-top: 90px;
  }

  .con-img {
    width: 1500px;
    height: auto;
    display: block;
    margin: 30px auto 0;
  }

  .tupu-con {
    position: relative;

    .to-tupu {
      cursor: pointer;

      width: 1200px;
      height: 296px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  // .tupu-img{
  //   display: block;
  //   width: 90%;
  //   height: ;
  // }
}

.recommend-class-box {
  margin-top: -140px;
  position: relative;
  z-index: 2;
  width: 100%;
  height: 872px;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("../../assets/image/sccj/bottom-bg.png");
  background-size: cover;

  .title-img {
    margin-top: 100px;
    margin-bottom: 40px;
  }

  .second-cate {
    width: 100%;
    text-align: center;
    margin-bottom: 40px;

    .second-item {
      cursor: pointer;
      display: inline-block;
      margin: 0 6px;
      font-weight: 400;
      font-size: 14px;
      color: #ffeb9d;
      height: 32px;
      line-height: 32px;
      padding: 0 16px;
      background: #c73d37;
      border-radius: 16px;

      &.active,
      &:hover {
        font-weight: 600;
        font-size: 14px;
        color: #bc1717;
        background: #ffeb9d;
        box-shadow: 0px 0px 8px 0px rgba(130, 130, 130, 0.2);
      }
    }
  }

  .class-outer-box {
    .more-link {
      width: 90px;
      display: block;
      font-size: 12px;
      text-align: center;
      color: #fce9ce;
      padding: 10px 0 0;
      cursor: pointer;
      padding: 0 12px;
      margin: 15px auto;
      background: #c73d37;
      border-radius: 16px;
      height: 26px;
      line-height: 26px;
    }

    .class-list {
      padding-bottom: 20px;

      .class-item {
        position: relative;
        padding: 25px 34px 0 50px;
        box-sizing: border-box;
        width: 374px;
        height: 168px;
        background: linear-gradient(0deg, #ffffff 79%, #fff3db 100%);
        border-radius: 4px;
        margin-bottom: 20px;

        .type-icon {
          position: absolute;
          left: 15px;
          display: inline-block;
          margin-right: 6px;
          width: 25px;
          height: 23px;

          &.word {
            background: url("../../assets/image/home/word.png") no-repeat center;
            background-size: 100% auto;
          }

          &.video {
            background: url("../../assets/image/home/MP4.png") no-repeat center;
            background-size: 100% auto;
          }
        }

        .res-label {
          font-weight: bold;
          font-size: 16px;
          color: #272727;
          line-height: 26px;
          height: 52px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .res-tags {
          margin: 15px 0 10px;
          height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;

          // white-space: nowrap;
          .tag-one {
            display: inline-block;
            height: 24px;
            margin-right: 6px;
            margin-bottom: 4px;
            line-height: 24px;
            background: #faf5f5;
            border-radius: 2px;
            padding: 0 8px;
            font-weight: 400;
            font-size: 12px;
            color: #ae7c6d;
          }
        }

        .source {
          font-weight: 400;
          font-size: 12px;
          color: #acacac;
        }
      }

      .sub-visibility {
        width: 374px;
        overflow: visible;
      }
    }

    /deep/ .swiper-pagination {
      width: 100%;
      bottom: -6px;

      .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        background: #E67575;
        border-radius: 50%;
        margin: 0 7px;
      }

      .swiper-pagination-bullet.swiper-pagination-bullet-active {
        background: #FFFFFF;
        opacity: 1;
      }
    }
  }
}

@media screen and (max-width: 1600px) {
  .tupu-data-box {
    .con-img {
      width: 90%;
      min-width: 1080px;
    }

    .to-tupu {
      width: 72% !important;
      height: 50% !important;

      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
